"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatDeep = exports.flat = void 0;
var flat = function (arr, d) {
    if (d === void 0) { d = 1; }
    return typeof arr.flat === 'function' ? arr.flat(d) : (0, exports.flatDeep)(arr, d);
};
exports.flat = flat;
var flatDeep = function (arr, d) {
    if (d === void 0) { d = 1; }
    return d > 0
        ? arr.reduce(function (acc, val) {
            return acc.concat(Array.isArray(val) ? (0, exports.flatDeep)(val, d - 1) : val);
        }, [])
        : arr.slice();
};
exports.flatDeep = flatDeep;
